<template>
  <div>
    <sys-select-base
        :model.sync="selected"
        :items="items"
        :loading="loading"
        :label="label"
        :error="error"
        :errors="errors"
        :clearable="clearable"
        :showAdd="showAdd"
        :hint="hint"
        :autoComplete="autoComplete"
        persistent-hint
    />
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'SysSelectInstitutionIntegrationItem',
  data: () => ({
    items: [],
    loading: false,
    selected: null
  }),
  created() {
    this.getItems();
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
    },
    label: {
      type: String,
      required: false
    },
    hint: {
      type: String,
      required: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    showAdd: {
      type: Boolean,
      default: false
    },
    autoComplete: {
        type: Boolean,
        default: false
    },
    model: {}
  },
  watch: {

    selected(val){
      this.$emit('update:model', val);
    },

    model(val){
      this.selected = val;
    },
  },
  methods: {
    ...mapActions('integration', ['ActionIndexIntegrationItemsInstitution']),
    async getItems() {
      this.loading = true;
      
      await this.ActionIndexIntegrationItemsInstitution()
          .then((res) => {
            this.items = res.data;
            this.selected = this.model;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>